<template>
  <aside class="ts-sidebar">
    <div class="ts-sidebar__brand">
      <img v-if="logoSrc" :src="logoSrc" class="ts-sidebar__logo" :alt="parkName" />
      <span v-else class="ts-sidebar__park-name">{{ parkName }}</span>
    </div>

    <nav class="ts-sidebar__nav" aria-label="Portal del inquilino">
      <router-link
        v-for="item in mainItems"
        :key="item.to"
        :to="item.to"
        class="ts-sidebar__item"
        :class="{ 'ts-sidebar__item--active': item.match(route.path) }"
      >
        <span class="mdi" :class="item.icon"></span>
        {{ item.label }}
      </router-link>
    </nav>

    <div class="ts-sidebar__bottom">
      <router-link
        :to="accountItem.to"
        class="ts-sidebar__item"
        :class="{ 'ts-sidebar__item--active': accountItem.match(route.path) }"
      >
        <span class="mdi" :class="accountItem.icon"></span>
        {{ accountItem.label }}
      </router-link>
      <button class="ts-sidebar__item ts-sidebar__logout" @click="onLogout">
        <span class="mdi mdi-logout"></span>
        Cerrar sesión
      </button>
    </div>
  </aside>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/services/authStore'
import { useTenantPortalStore } from '@/services/tenantPortalStore'
import { tenantNavItems, tenantAccountItem, parkLogoSrc } from './tenantNav'

const route = useRoute()
const router = useRouter()
const { state, logout } = useAuthStore()
const { resetTenantPortal } = useTenantPortalStore()

const parkName = computed(() => state.user?.parkName || '')
const logoSrc = computed(() => parkLogoSrc(state.user?.parkLogoUrl))
const mainItems = computed(() => tenantNavItems(state.user?.sections, state.user?.contractCount))
const accountItem = tenantAccountItem

async function onLogout() {
  await logout()
  resetTenantPortal()
  router.push('/login')
}
</script>

<style scoped>
.ts-sidebar {
  width: 220px; flex-shrink: 0; height: 100%;
  display: flex; flex-direction: column;
  background: #1e3a5f; color: #fff;
}
.ts-sidebar__brand {
  height: 72px; padding: 0 20px; flex-shrink: 0;
  display: flex; align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.ts-sidebar__logo { max-width: 100%; max-height: 44px; object-fit: contain; display: block; }
.ts-sidebar__park-name { font-family: var(--font-display); font-weight: 700; font-size: 14px; color: #fff; line-height: 1.25; }
.ts-sidebar__nav { flex: 1; padding: 12px 10px; display: flex; flex-direction: column; gap: 2px; }
.ts-sidebar__bottom {
  padding: 10px; display: flex; flex-direction: column; gap: 2px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.ts-sidebar__item {
  display: flex; align-items: center; gap: 10px; width: 100%;
  padding: 10px 12px; border-radius: 6px; border: none; background: none; cursor: pointer;
  font: 500 13px Inter, sans-serif; color: rgba(255, 255, 255, 0.7); text-decoration: none; text-align: left;
}
.ts-sidebar__item .mdi { font-size: 18px; }
.ts-sidebar__item:hover { background: rgba(255, 255, 255, 0.08); color: #fff; }
.ts-sidebar__item--active { background: rgba(255, 255, 255, 0.14); color: #fff; }

@media (max-width: 768px) {
  .ts-sidebar { display: none; }
}
</style>